import React from 'react';

import { Text, useTheme } from '@simplybusiness/mobius-core';
import { withPartnerTheme } from '@simplybusiness/mobius-simplybusiness';

const ErrorMessage = withPartnerTheme(({ children }) => {
  const { theme } = useTheme();

  return <Text marginTop={8} marginBottom={0} fontSize={14} color={theme.colors.error}>{children}</Text>;
});

export default ErrorMessage;
